module.exports = __webpack_public_path__ + "static/media/navigation.3078108a.svg";